
const PreviewImage = ({ data, src }) => {

  return (
    <img
      src={src}
      alt={data.description}
      onContextMenu={(e) => e.preventDefault()}
      height="100%"
    />
  )
}

export default PreviewImage